
import { defineComponent } from 'vue';
import store from '@/store';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import ExternalTransactionsTable from './ExternalTransactionsTable.vue';
import CustomPaginationComponent from '../appComponents/CustomPagination.vue';
import router from '@/router';

export default defineComponent({
    name: 'GatewayTransactionsTableComponent',
    props: {
        gateways: {
            type: Array as () => any[],
            default: () => [],
        },
    },
    components: {
        ExternalTransactionsTable,
        CustomPaginationComponent,
    },
    data() {
        return {
            showGatewayTransactions: false,
            tableHeaders: [
                { title: 'عنوان درگاه', key: 'title', sortable: false },
                { title: 'ایمیل', key: 'email', sortable: false },
                { title: 'دامنه', key: 'domain', sortable: false },
                { title: 'تراکنش‌ها', key: 'transactions', sortable: false },
                { title: 'تنظیمات', key: 'settings', sortable: false },
                { title: 'وضعیت', key: 'verifyStatus', sortable: false },
            ],
        };
    },
    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
        getGatewayInfo(): any {
            return store.getters['panel/getGatewayInfo'];
        },
        getGatewayTransactions(): any[] {
            return store.getters['panel/getGatewayTransactions'];
        },
    },
    methods: {
        rowClass(_: any, index: number): string {
            return index % 2 === 0 ? 'bg-gray-200' : '';
        },
        toggleGatewayVerifyStatus(gateway: any) {
            const toggleData = {
                gatewayId: gateway.id,
                status: gateway.verifyStatus === 'PENDING' ? 'APPROVED' : 'PENDING',
            };
            store.dispatch('panel/toggleGatewayStatusRequest', toggleData);
        },
        handelPagination() {
            store.dispatch('panel/getGatewayTransactionsRequest');
        },
        showGatewayTransactionsList(gateway: any) {
            router.push({ name: 'GatewayTransactions', query: { gateway: gateway.id } });
        },
        showGatewaySettings(gateway: any) {
            router.push({ name: 'GatewaySettings', query: { gateway: gateway.id } });
        },
    },
});
